/** „Anna Beispiel“ → „AB“, „Anna“ → „A“, leer → null (wie `ProfilZeichen.initialen` in iOS). */
export function initialen(name: string | null | undefined): string | null {
  const teile = (name ?? "").trim().split(/\s+/).filter(Boolean);
  const erster = teile[0]?.charAt(0);
  if (!erster) return null;
  const letzter = teile.length > 1 ? teile[teile.length - 1]?.charAt(0) : undefined;
  return (erster + (letzter ?? "")).toUpperCase();
}

/** Schluessel des Servers (`plaene.py`) als Name: frei → Free, sonst grossgeschrieben (wie iOS). */
export function planName(schluessel: string): string {
  const bekannt: Record<string, string> = { frei: "Free", basis: "Basis", plus: "Plus", premium: "Premium" };
  return bekannt[schluessel] ?? schluessel.charAt(0).toUpperCase() + schluessel.slice(1);
}
